import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Card } from 'ui';
import { useSnack, useError } from 'hooks';
import { useTranslation } from 'react-i18next';
import { Header } from 'components';
import { initialLocale } from 'utils';
import ExperienceThemeForm from '../../../components/Forms/ExperienceThemeForm';
import { createTheme } from 'api/node/themes';

const CreateTheme = () => {
  const { t } = useTranslation('experienceTheme');
  const [currentLocale, setCurrentLocale] = useState(initialLocale);
  const navigate = useNavigate();
  const { notify } = useSnack();
  const { sendErrorSnack } = useError();

  const handleCreateTheme = async (values) => {
    try {
      const data = await createTheme({
        payload: values,
        locale: currentLocale.value,
      });

      if (data?.errors?.length > 0) {
        throw data?.errors?.[0];
      }

      navigate(-1);
      notify(t('createThemeSuccess'));
    } catch (err) {
      sendErrorSnack(err);
    }
  };

  return (
    <>
      <Header />

      <Container size="narrow">
        <Card>
          <ExperienceThemeForm
            onSubmit={handleCreateTheme}
            queryLocale={currentLocale}
            updateQueryLocale={setCurrentLocale}
            disabledCreate={currentLocale.value !== initialLocale.value}
          />
        </Card>
      </Container>
    </>
  );
};

export default CreateTheme;
